const otpTypeEnum = Object.freeze([
    {
        id: "5",
        name: "BOTH",
    },
    {
        id: "10",
        name: "SMS",
    },
    {
        id: "15",
        name: "EMAIL",
    },
]);
export default otpTypeEnum;
